import styled from "styled-components";

export const BoxContainer = styled.div`
  display: flex;  
  /* background-color:green; */
  padding: 1rem;
  width: 50%;
  max-width: 400px;
  min-width: 300px;
  flex-direction: column;  
  box-shadow: rgb(0 0 0 / 25%) 5px 5px 10px;
`;
